export const containsOpenFund = (data) =>
    data && data.some((x) => x.openToNewInvestors);

export const containsAClosedFund = (data) =>
    data && data.some((f) => !f.openToNewInvestors);
